export function formatCentsAsUsd(cents: number): string {
  const n = cents / 100;
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n);
}
